/* eslint-disable import/no-cycle */
import { Box } from '@chakra-ui/core';
import React from 'react';
import { Branch } from '../../../questionnaireTemplate.enums';
import { QuestionnaireTemplateStore } from '../../../store/questionnaireTemplateModel';
import { DropZone } from '../../formBuilderComponents/Dropzone';
import { SortableElement } from '../../formBuilderComponents/SortableElement';
import { BranchLabel } from './QuestionBranchLabel';

const EMPTY_ARRAY: string[] = [];

interface QuestionBranchSectionProps {
  parentId: string;
  branchName: Branch;
  isOnlyBranch: boolean;
  availableOptions: Branch[];
}

export const QuestionBranchSection = React.memo(function QuestionBranchSection({
  parentId,
  branchName,
  isOnlyBranch,
  availableOptions,
}: QuestionBranchSectionProps) {
  const branchKey = `${parentId}-${branchName}`;
  const branchChildrens = QuestionnaireTemplateStore.useStoreState((state) => state.ordering[branchKey] ?? EMPTY_ARRAY);

  const hasChildren = branchChildrens.length > 0;
  return (
    <Box
      data-testid="branch-section"
      mb={4}
      _last={{ mb: 0 }}
      sx={{ background: '#F9F9F9', borderRadius: 'md', border: '1px solid #E5E7EB', padding: 4 }}
    >
      <BranchLabel branchName={branchName} parentId={parentId} isOnlyBranch={isOnlyBranch} availableOptions={availableOptions} />
      <Box>
        {hasChildren ? (
          <React.Fragment>
            <DropZone parentId={parentId} branch={branchName} index={0} />
            {branchChildrens.map((childId, idx) => (
              <React.Fragment key={childId}>
                <SortableElement id={childId} parentId={parentId} branch={branchName} />
                <DropZone parentId={parentId} branch={branchName} index={idx + 1} />
              </React.Fragment>
            ))}
          </React.Fragment>
        ) : (
          <DropZone parentId={parentId} branch={branchName} index={0} isInitial />
        )}
      </Box>
    </Box>
  );
});
